// extracted by mini-css-extract-plugin
export default {"main":"footer_main__mCYPY"};